import { Switch } from 'antd';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import type { Switcher } from '../../../../shared/entities/control-entities';

import styles from './new-well-switcher-feature.module.scss';

type Props = {
  className?: string;
  item: Switcher;
  isDisabled: boolean;
  onBlur?: VoidFunction;
  onChange(value: unknown): void;
};

export const NewWellSwitcherFeature = observer(function NewWellSwitcherFeature({
  className,
  item,
  isDisabled,
  onBlur,
  onChange,
}: Props) {
  const handleChange = (value: boolean) => {
    onChange(value);
  };

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Switch checked={item.value} disabled={isDisabled} onChange={handleChange} onClick={onBlur} />
    </div>
  );
});
